/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locales_Es_419Inputs */

const en_us2_locales_es_419 = /** @type {(inputs: Locales_Es_419Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español (Latinoamérica)`)
};

const pt_br2_locales_es_419 = /** @type {(inputs: Locales_Es_419Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español (Latinoamérica)`)
};

const es_419_locales_es_419 = /** @type {(inputs: Locales_Es_419Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español (Latinoamérica)`)
};

const pt_pt2_locales_es_419 = /** @type {(inputs: Locales_Es_419Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español (Latinoamérica)`)
};

const fr_fr2_locales_es_419 = /** @type {(inputs: Locales_Es_419Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español (Latinoamérica)`)
};

const de_de2_locales_es_419 = /** @type {(inputs: Locales_Es_419Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español (Latinoamérica)`)
};

const it_it2_locales_es_419 = /** @type {(inputs: Locales_Es_419Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Español (Latinoamérica)`)
};

/**
* | output |
* | --- |
* | "Español (Latinoamérica)" |
*
* @param {Locales_Es_419Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const locales_es_419 = /** @type {((inputs?: Locales_Es_419Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locales_Es_419Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_locales_es_419(inputs)
	if (locale === "es-419") return es_419_locales_es_419(inputs)
	if (locale === "pt-PT") return pt_pt2_locales_es_419(inputs)
	if (locale === "fr-FR") return fr_fr2_locales_es_419(inputs)
	if (locale === "de-DE") return de_de2_locales_es_419(inputs)
	if (locale === "it-IT") return it_it2_locales_es_419(inputs)
	return en_us2_locales_es_419(inputs)
});
export { locales_es_419 as "locales.es_419" }